import { render } from "./UnbindPost.vue?vue&type=template&id=a0b5625e"
import script from "./UnbindPost.vue?vue&type=script&lang=js"
export * from "./UnbindPost.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__